
import { AutocompleteInput, Filter, NullableBooleanInput, ReferenceInput, SelectInput } from "react-admin";


const PhotoFilter = (props: any) => (
    <Filter {...props}>

        <SelectInput source="moderation" alwaysOn choices={[
            { id: 'null', name: 'Not moderated' },
            { id: 'any', name: 'Moderated' },
            { id: 'rejected', name: 'Rejected' },
            { id: 'accepted', name: 'Accepted' },
            { id: 'all', name: 'All' },
        ]} />
        <NullableBooleanInput label="Approved" source="approved" alwaysOn />
        <ReferenceInput label="User" source="user" reference="user" allowEmpty alwaysOn>
            <AutocompleteInput optionText="profile.nickname"
                filterToQuery={(txt) => ({ profile: { nickname: txt } })}
                size='small'
            />
        </ReferenceInput>

        <ReferenceInput label="Email" source="user" reference="user" allowEmpty alwaysOn >
            {/* TODO: review autocomplete to load filtered nicknames while typing */}
            <AutocompleteInput optionText="email" label="Email"
                filterToQuery={(txt) => ({ email: txt })}
                size='small'
            />
        </ReferenceInput>
        {/* <ReferenceInput label="User" source="userId" reference="users" allowEmpty>
            <SelectInput optionText="name" />
        </ReferenceInput> */}
    </Filter>
)


export default PhotoFilter;